<template>
  <div>
    <template v-if="saved">
      <div class="m-b-lg">
        <h1 class="font-heavy text-green-600 flex align-items-center gap-x-sm">
          <i class="fa-solid fa-circle-check"></i>
          Kiosk Updated
        </h1>
      </div>

      <div class="row m-t-m">
        <div class="col-md-4">
          <h2 class="form-section-title">Kiosk Details</h2>
        </div>
        <div class="col-md-8">
          <div class="form-group">
            <label class="text-gray-500 uppercase tracking-wide text-12 font-semi">Kiosk Name</label>
            <p class="font-heavy text-gray-700 m-t-xs m-b-none">{{ name }}</p>
          </div>
          <div class="form-group m-t-m">
            <label class="text-gray-500 uppercase tracking-wide text-12 font-semi">Sign-in Code</label>
            <p class="m-t-xs m-b-none">
              <span class="font-heavy text-gray-900" style="font-size: 1.25rem; letter-spacing: 0.05em;">{{ kioskToken.token }}</span>
            </p>
            <p class="text-gray-500 text-14 m-t-xs">
              Use this code at <a href="https://kiosk.wrestlingiq.com" target="_blank" class="text-underline">kiosk.wrestlingiq.com</a> to sign in
            </p>
          </div>
          <div class="form-group m-t-m">
            <label class="text-gray-500 uppercase tracking-wide text-12 font-semi">Admin PIN</label>
            <p class="m-t-xs m-b-none">
              <span v-if="adminPin" class="font-heavy text-gray-900" style="font-size: 1.25rem; letter-spacing: 0.1em;">{{ adminPin }}</span>
              <span v-else class="text-gray-400">Not set</span>
            </p>
          </div>
        </div>
      </div>

      <div class="hr-line-dashed m-t-lg m-b-lg"></div>

      <a :href="indexUrl" class="text-gray-700 flex align-items-center gap-x-xs">
        <i class="fa-solid fa-arrow-left"></i>
        Back to Kiosks
      </a>
    </template>
    <template v-else>
      <div role="form">
        <div class="form-group m-t-m">
          <label>Kiosk name</label>
          <input v-model="name" type="text" class="form-control" placeholder="e.g. Front desk iPad">
        </div>
        <div class="form-group m-t-m">
          <label>Admin PIN</label>
          <input v-model="adminPin" type="text" class="form-control" placeholder="4-digit PIN" maxlength="4" pattern="\d{4}">
          <small class="text-muted">Used to access admin features on the kiosk</small>
        </div>
        <div class="button-area text-right">
          <div v-show="error">
            <small>
              <span class="text-danger">{{ errorMessage }}</span>
            </small>
          </div>
          <a :href="indexUrl" class="btn btn-default m-r-sm">Cancel</a>
          <ladda-button @lbClicked="updateToken" el-class="btn-primary" :loading="loading">
            Save Changes
          </ladda-button>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import LaddaButton from '../../shared/ladda_button.vue';
import { errorableMix } from './mixins/errorable_mix';

export default {
  name: 'kiosk-token-edit',
  components: { LaddaButton },
  mixins: [errorableMix],
  props: {
    kioskToken: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      name: this.kioskToken.name,
      adminPin: this.kioskToken.admin_pin || '',
      saved: false,
    };
  },
  computed: {
    indexUrl() {
      return '/kiosk_tokens';
    },
  },
  methods: {
    updateToken: _.throttle(function () {
      const vm = this;

      if (vm.loading === true) {
        return;
      }

      if (vm.name.length === 0) {
        this.errorMessage = 'A Kiosk name is required';
        this.error = true;
        return;
      }

      if (vm.adminPin.length > 0 && !/^\d{4}$/.test(vm.adminPin)) {
        this.errorMessage = 'Admin PIN must be exactly 4 digits';
        this.error = true;
        return;
      }

      vm.loading = true;
      const params = {
        kiosk_token: {
          name: vm.name,
          admin_pin: vm.adminPin,
        },
      };
      const url = vm.$apiService.kioskTokenUrl(vm.kioskToken.id);
      axios.put(url, params)
        .then(() => {
          vm.loading = false;
          vm.saved = true;
        })
        .catch(() => {
          vm.loading = false;
          vm.errorMessage = 'Error, please try again later or contact support@wrestlingiq.com';
          vm.error = true;
        });
    }, 500),
  },
};
</script>
